import { createStore } from 'zustand/vanilla';
function sameInputs(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length)
        return false;
    return aKeys.every(key => a[key] === b[key]);
}
/**
 * Vanilla external-store factory shared by every chain package's
 * `create*Connection` implementation. Owns the "compute inputs, compare by
 * identity, rebuild the snapshot only when something changed, notify the store
 * only on a new snapshot" cycle so chain packages declare just their inputs,
 * snapshot builder, and subscriptions.
 */
export function createMemoizedConnectionStore(config) {
    let lastInputs = null;
    let lastSnapshot = null;
    const computeSnapshot = () => {
        const inputs = config.computeInputs();
        if (lastInputs && lastSnapshot && sameInputs(lastInputs, inputs)) {
            return lastSnapshot;
        }
        const snapshot = config.buildSnapshot(inputs);
        lastInputs = inputs;
        lastSnapshot = snapshot;
        return snapshot;
    };
    const store = createStore(() => computeSnapshot());
    const sync = () => {
        const next = computeSnapshot();
        if (store.getState() === next)
            return;
        store.setState(next, true);
    };
    const unsubs = config.subscribe?.(sync) ?? [];
    return {
        store,
        updateProps(nextProps) {
            config.onUpdateProps?.(nextProps);
            sync();
        },
        destroy() {
            unsubs.forEach(u => u());
            config.onDestroy?.();
        },
    };
}
